import { createFileRoute } from '@tanstack/react-router'
import { CandidatesSearchPage } from '@/features/candidates/components/candidates-search-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/candidates',
)({
  component: CandidatesSearchPage,
  beforeLoad: () => ({
    title: 'Candidates',
    headerTitleKey: 'header.candidates.title',
    headerDescriptionKey: 'header.candidates.description',
  }),
})
